import { takeLatest, call, put } from 'redux-saga/effects'
import certificatesList from 'api/administration/certificates/List'
import editCertificate from 'api/administration/certificates/Edit'

import * as fromActions from 'store/actions/certificates.action'
import { ICertificate } from 'models/certificate.model'

import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'


async function getList() {
  return await certificatesList()
}

async function handleEdit(data: ICertificate, idCertificate: number) {
  return await editCertificate(data, idCertificate)
}

function* editCertificateEffectSaga(action: any) {
  try {

    const { data: certificate, certificateId } = action.payload

    yield call(handleEdit, certificate, certificateId)

    const { data } = yield call(getList)
    yield put(fromActions.Actions.certificateAdministrationListSuccess(data))

    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editCertificateWatcherSaga() {
  yield takeLatest(fromActions.UPDATE_CERTIFICATE, editCertificateEffectSaga)
}